<template>
  <div class="income-cost-list">
    <el-container>
      <el-header>
        <el-form
          :model="queryFormData"
          :inline="true"
          label-width="120px"
          label-position="left"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="项目部">
                <el-select
                  v-model="queryFormData.deptId"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="dept in deptList"
                    :key="dept.applyDeptId"
                    :label="dept.applyDeptName"
                    :value="dept.applyDeptId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目名称">
                <el-input
                  v-model="queryFormData.projectName"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目所属年度">
                <el-date-picker
                  v-model="queryFormData.belongYear"
                  type="year"
                  placeholder="请选择"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <template v-if="showAdvanceFilter">
              <el-col :span="6">
                <el-form-item label="工程进展">
                  <el-select
                    v-model="queryFormData.processStatus"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="process in processStatusListForSelect"
                      :key="process.id"
                      :label="process.value"
                      :value="process.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="开始日期">
                  <el-date-picker
                    v-model="queryFormData.historyDateStart"
                    type="month"
                    placeholder="选择月份"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="结束日期">
                  <el-date-picker
                    v-model="queryFormData.historyDateEnd"
                    type="month"
                    placeholder="选择月份"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审批状态">
                  <el-select
                    v-model="queryFormData.approveStatus"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in approveStatusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </template>

            <el-col :span="6">
              <el-form-item>
                <div class="search-btns">
                  <el-button type="primary" icon @click="getList"
                    >查询</el-button
                  >
                  <el-button type="info" icon @click="resetQuery"
                    >重置</el-button
                  >
                  <el-button type="text" @click="toggleAdvance">{{
                    showAdvanceFilter ? "收起" : "高级筛选"
                  }}</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="text-align: right;margin-top: 16px;">
            <!-- <el-button type="primary" @click="getList" icon="el-icon-search"
              >查询</el-button
            >
            <el-button type="primary" @click="resetQuery" icon="el-icon-refresh"
              >重置</el-button
            > -->
            <el-button
              type="primary"
              v-if="btnAuthorize.addBtn.btnEnable"
              @click="addItem"
              icon="el-icon-plus"
              >新建</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.modifyBtn.btnEnable"
              @click="editItem"
              icon="el-icon-edit"
              >修改</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.callback.btnEnable"
              @click="recallItem"
              icon="el-icon-refresh-left"
              >撤回</el-button
            >
            <el-button
              type="primary"
              @click="editLog"
              icon="el-icon-warning-outline"
              v-if="btnAuthorize.logs.btnEnable"
              >修改记录</el-button
            >
            <el-button
              type="primary"
              @click="exportData"
              v-if="btnAuthorize.export.btnEnable"
              icon="el-icon-download"
              >导出</el-button
            >
          </el-row>
        </el-form>
      </el-header>
      <el-main>
        <el-table
          ref="dataTable"
          :data="tableList"
          highlight-current-row
          size="mini"
          height="100%"
          border
          @selection-change="handleSelectionChange"
          @row-click="handleRowClick"
          @row-dblclick="handleRowDbClick"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column
            label="项目部"
            :show-overflow-tooltip="true"
            prop="deptName"
          ></el-table-column>
          <el-table-column
            label="项目名称"
            :show-overflow-tooltip="true"
            prop="projectName"
          ></el-table-column>
          <el-table-column
            label="项目所属年度"
            :show-overflow-tooltip="true"
            prop="belongYear"
          ></el-table-column>
          <el-table-column
            label="工程进展"
            :show-overflow-tooltip="true"
            prop="projectProcess"
          ></el-table-column>
          <el-table-column label="合同金额" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ formatMoneyNumber(scope.row.contractAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="已完成工作量" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ formatMoneyNumber(scope.row.finishPriceSum) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="上报计量" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ formatMoneyNumber(scope.row.calculatePriceSum) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="已收计量金额" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ formatMoneyNumber(scope.row.receiptPriceSum) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="收集团拨款金额" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ formatMoneyNumber(scope.row.groupAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作用户"
            :show-overflow-tooltip="true"
            prop="operatorName"
          >
          </el-table-column>
          <el-table-column
            label="操作日期"
            :show-overflow-tooltip="true"
            prop="updateTime"
          >
          </el-table-column>
          <el-table-column
            label="审批状态"
            prop="approveStatusShow"
          >
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>

    <!-- 修改记录的弹出框 -->
    <el-dialog title="修改记录" :visible.sync="logDialogVisible" width="40%">
      <el-table
        :data="logDialogList"
        highlight-current-row
        size="mini"
        height="100%"
        border
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column label="操作时间" prop="createTime"></el-table-column>
        <el-table-column label="操作用户" prop="operatorName"></el-table-column>
      </el-table>
      <div style="margin-top: 16px; text-align: right;">
        <el-pagination
          @current-change="handleLogCurrentChange"
          :current-page="logDialogPageIndex"
          :page-size="logDialogPageSize"
          layout="total, prev, pager, next, jumper"
          :total="logDialogTotal"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="logDialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" @click="logDialogVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="导出" :visible.sync="exportDialogVisible" width="400px">
      <!-- 收入成本管理-导出 -->
      <div>
        <el-checkbox v-model="export1Checked">收入成本确认表</el-checkbox>
      </div>
      <div>
        <el-checkbox v-model="export2Checked">收入成本汇总表</el-checkbox>
      </div>
      <div>
        <el-checkbox v-model="export3Checked">收支明细表</el-checkbox>
      </div>
      <div>
        <el-checkbox v-model="export4Checked">工程成本明细表</el-checkbox>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="exportDialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" @click="confirmExportData">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//----------------------
//收入成本管理-列表页，收入列表
//---------------------
import {
  getProcessStatusList,
  getDeptList,
  getEarningConstList,
  getIncomingConstItemLog,
  earningCostExportapi,
  recallFinanceApi
} from "../../services/financeService";
import Constants, {
  formatQueryDate,
  formatQueryYear
} from "../../utils/consts";
import { formatMoney } from "./utils";
export default {
  data() {
    return {
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        export: { key: "export", btnEnable: false }, // 导出
        logs: { key: "logs", btnEnable: false },
        callback: { key: 'callback', btnEnable: false }
      },
      showAdvanceFilter: false,
      queryFormData: {
        deptId: undefined, //项目部
        projectName: "", //项目名称
        belongYear: undefined, //项目所属年份
        processStatus: undefined, //工程进展
        historyDateStart: undefined,
        historyDateEnd: undefined,
        approveStatus: 0
      },
      pageIndex: 1,
      pageSize: 10,
      deptList: [], // 项目部选择项
      processStatusListForSelect: [], //工程进展的可选项
      tableList: [], // 表格数据
      total: 0,
      selectedItems: [],
      logDialogPageIndex: 1,
      logDialogPageSize: 10,
      logDialogVisible: false,
      logDialogTotal: 0,
      logDialogList: [],
      exportDialogVisible: false,
      export1Checked: true,
      export2Checked: true,
      export3Checked: true,
      export4Checked: true,
      // 1撤回2审批中3已通过4已拒绝
      approveStatusList: [
        {
          value: 0,
          label: "全部"
        },
        {
          value: 1,
          label: "撤回"
        },
        {
          value: 2,
          label: "待审批"
        },
        {
          value: 3,
          label: "已通过"
        },
        {
          value: 4,
          label: "已拒绝"
        }
      ]
    };
  },
  methods: {
    toggleAdvance() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
    },
    formatMoneyNumber: formatMoney,
    onActive(menuCode) {
      this.getProcessStatusListForSelect();
      this.getDepttListForSelect();
      this.getList();
      this.$getRoleBtns(menuCode, this.btnAuthorize);
    },
    getProcessStatusListForSelect() {
      getProcessStatusList()
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.processStatusListForSelect = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    getDepttListForSelect() {
      getDeptList()
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.deptList = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    getList() {
      getEarningConstList({
        deptId: this.queryFormData.deptId,
        historyDateEnd: formatQueryDate(this.queryFormData.historyDateEnd),
        historyDateStart: formatQueryDate(this.queryFormData.historyDateStart),
        belongYear: formatQueryYear(this.queryFormData.belongYear),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        projectName: this.queryFormData.projectName,
        projectProcess: this.queryFormData.processStatus,
        approveStatus: this.queryFormData.approveStatus
          ? this.queryFormData.approveStatus
          : undefined // 不传就是查全部
      })
        .then(res => {
          console.log("----回来的数据", res);
          if (res.code == Constants.Code_OK) {
            this.tableList = res.data || [];
            this.total = res.total;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    resetQuery() {
      this.queryFormData = {
        deptId: undefined, //项目部
        projectName: "", //项目名称
        belongYear: undefined, //项目所属年份
        processStatus: undefined, //工程进展
        historyDateStart: undefined,
        historyDateEnd: undefined
      };
      this.pageIndex = 1;
      this.getList();
    },
    addItem() {
      this.bus.$emit("navMenuChange", {
        routeId: "CreateEarningItem"
      });
    },
    editItem() {
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert("请先选择要操作的目标数据", "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert("只能操作单条数据", "提示");
        return;
      }
      let target = this.selectedItems[0];
      // console.log("选中项", target.id, target.isHistory, target);
      if (target.isHistory == 1) {
        this.$alert("历史记录不允许修改", "提示");
        return;
      }
      /**
       * fix：原来根据isHistory来判断是否能修改，现在根据状态来判断
       * 2022-09-21 09:15:58
       * approveStatus 是字符串，1-撤回，2-待审批，3-已通过，4-驳回
       */
      if(target.approveStatus == '2') {
        this.$alert("待审批记录不允许修改", "提示");
      } else {
        this.bus.$emit("navMenuChange", {
          routeId: "EditEarningItem",
          routeParam: {
            id: target.id
          }
        });
      }
    },
    editLog() {
      // 查看修改记录，看的是某条数据对应的.翻页的
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert("请先选择要查看的目标数据", "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert("只能查看单条数据的日志", "提示");
        return;
      }
      let target = this.selectedItems[0];
      // 第一次打开，获取数据第1页数据
      this.logDialogPageIndex = 1;
      this.logDialogList = [];
      getIncomingConstItemLog({
        earningCostId: target.id,
        pageIndex: this.logDialogPageIndex,
        pageSize: this.logDialogPageSize
      })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.logDialogList = res.data || [];
            this.logDialogTotal = res.total;
            if (this.logDialogList.length == 0) {
              this.$alert("暂无修改记录", "提示");
            } else {
              this.logDialogVisible = true;
            }
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    handleLogCurrentChange(page) {
      this.logDialogPageIndex = page;
      let target = this.selectedItems[0];
      getIncomingConstItemLog({
        earningCostId: target.id,
        pageIndex: this.logDialogPageIndex,
        pageSize: this.logDialogPageSize
      })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.logDialogList = res.data || [];
            this.logDialogTotal = res.total;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    exportData() {
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert("请选择要导出的数据", "提示");
        return;
      }
      this.export1Checked = true;
      this.export2Checked = true;
      this.export3Checked = true;
      this.export4Checked = true;
      this.exportDialogVisible = true;
    },
    confirmExportData() {
      let exportTabs = [];
      if (this.export1Checked) {
        exportTabs.push(1);
      }
      if (this.export2Checked) {
        exportTabs.push(2);
      }
      if (this.export3Checked) {
        exportTabs.push(3);
      }
      if (this.export4Checked) {
        exportTabs.push(4);
      }
      let ids = this.selectedItems.map(item => item.id);
      earningCostExportapi({
        exportIds: ids,
        exportTabs: exportTabs
      })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            console.log("=======", res.data);
            let url = res.data;
            const a = document.createElement("a");
            a.href = url;
            a.download = "收入成本";
            a.click();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert("操作失败", "提示");
        })
        .finally(() => {
          this.exportDialogVisible = false;
        });
    },
    handleSelectionChange(val) {
      this.selectedItems = val || [];
    },
    handleRowClick(row, column) {
      if (!this.selectedItems) {
        this.selectedItems = [row];
      } else {
        let index = this.selectedItems.indexOf(row);
        if (index != -1) {
          this.selectedItems.splice(index, 1);
        } else {
          this.selectedItems.push(row);
        }
      }
      this.$refs["dataTable"].toggleRowSelection(row);
    },
    handleRowDbClick(row, column) {
      // 某一行数据被双击，就是查看详情
      this.bus.$emit("navMenuChange", {
        routeId: "incomingConstDetail",
        routeParam: {
          id: row.id,
          approveStatus: row.approveStatus
        }
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.getList();
    },
    handleCurrentChange(page) {
      this.pageIndex = page;
      this.getList();
    },
    recallItem() {
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert("请选择要撤回的数据", "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert(Constants.One_Select_Tip, "提示");
        return;
      }
      console.log('---selectedItems', this.selectedItems);
      const { approveStatus, id,  } = this.selectedItems[0];
      // 待审批的可以撤回
      if(approveStatus != 2) {
        this.$alert("选择的数据不能撤回", "提示");
        return ;
      }

      this.$confirm("您确定要撤回选定的数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return recallFinanceApi({ itemId: id, type: 'EARNING_COST' });
        })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.$alert(Constants.Ok_Msg, "提示");
            // 撤回成功后，刷新一下当前页码的数据。
            // 省点的就是修改单条提报单的数据，重新获取的好处就是能获取全部的最新数据。
            this.getList();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";
.income-cost-list {
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
}

.search-btns {
  text-align: right;
}
</style>
